<template>
  <v-container class="background-color">
    <v-row align="center" justify="center">
      <!-- Datos Cuenta -->
      <AccountVue v-if="landingCounter === 1" />

      <!-- Fecha de entrega -->
      <DateVue v-if="landingCounter === 2" />

      <!-- Pago -->
      <PayVue v-if="landingCounter === 3" />

      <!-- Confirmación del servicio -->
      <ConfirmServiceVue v-if="landingCounter === 4" />
    </v-row>
    <ConoceMasVue />
    <CompleteLiters />
  </v-container>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import AccountVue from "../components/Account.vue";
import DateVue from "../components/Date.vue";
import PayVue from "../components/Pay.vue";
import ConfirmServiceVue from "../components/ConfirmService.vue";
import ConoceMasVue from "../components/ConoceMas.vue";
import CompleteLiters from "../components/CompleteLiters.vue";

export default {
  components: {
    AccountVue,
    DateVue,
    PayVue,
    ConfirmServiceVue,
    ConoceMasVue,
    CompleteLiters
  },
  computed: {
    ...mapFields(["landingCounter", "formOkBoy"]),
  },
  data() {
    return {
      // landingCounter: 1,
    };
  },
  mounted() {
    if (
      this.formOkBoy.cantidadGasEstacionario === null &&
      this.formOkBoy.cantidadGasCilindro === null
    ) {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style scoped>
.backgroundColor {
  background-color: #f1f3f6;
}
</style>